import { css } from '@emotion/css';

import { BREAKPOINT_QUERIES } from '@lyearn/core/hooks/useScreen';
import { cn } from '@lyearn/style';
import { ContentCardTypeEnum } from '@/modules/content/config/cards';
import { CONTENT_CARD_CLASSES } from '@/modules/content/utils/renderContentCard';

export const CARD_TYPE = ContentCardTypeEnum.Display;

export const carouselStyleOverrides = css`
  padding-inline-start: 0 !important;
  padding-inline-end: 0 !important;

  .keen-slider {
    margin-top: -1.2rem;
  }
`;

export const headerStyles = (isMobile?: boolean) =>
  isMobile
    ? 'mx-0'
    : css`
        margin-inline-start: 0.8rem;
        @media ${BREAKPOINT_QUERIES.Mobile} {
          margin-inline-start: 2.4rem;
        }
      `;

export const CLASSES = {
  carousel: cn(carouselStyleOverrides, ContentCardTypeEnum.Display),
  slide: CONTENT_CARD_CLASSES[CARD_TYPE],
};

export const carouselStyles = (isMobile: boolean) => css`
  .swiper-container,
  .keen-slider {
    padding: 1.2rem 0;
    margin: -1.2rem 0;
  }

  .keen-slider__slide {
    overflow: visible !important;
  }

  .swiper-wrapper {
    transition: transform cubic-bezier(0.215, 0.61, 0.355, 1.05) 0s;
  }

  &.DISPLAY {
    margin-bottom: -2rem;

    .carousel-navigation {
      top: 13.6rem;
    }
  }
`;
